export const PRODUCTINVENTORY_LOADING = "PRODUCTINVENTORY_LOADING";
export const PRODUCTINVENTORY_RESET = "PRODUCTINVENTORY_RESET";
export const GET_PRODUCTINVENTORY = "GET_PRODUCTINVENTORY";
export const GET_PRODUCTINVENTORY_SUCCESS = "GET_PRODUCTINVENTORY_SUCCESS";
export const GET_PRODUCTINVENTORY_FAIL = "GET_PRODUCTINVENTORY_FAIL";
export const DELETE_PRODUCTINVENTORY = "DELETE_PRODUCTINVENTORY"
export const DELETE_PRODUCTINVENTORY_SUCCESS = "DELETE_PRODUCTINVENTORY_SUCCESS"
export const DELETE_PRODUCTINVENTORY_FAIL = "DELETE_PRODUCTINVENTORY_FAIL"
export const UPDATE_PRODUCTINVENTORY = "UPDATE_PRODUCTINVENTORY"
export const UPDATE_PRODUCTINVENTORY_SUCCESS = "UPDATE_PRODUCTINVENTORY_SUCCESS"
export const UPDATE_PRODUCTINVENTORY_FAIL = "UPDATE_PRODUCTINVENTORY_FAIL"
export const ADD_NEW_PRODUCTINVENTORY = "ADD_NEW_PRODUCTINVENTORY"
export const ADD_PRODUCTINVENTORY_SUCCESS = "ADD_PRODUCTINVENTORY_SUCCESS"
export const ADD_PRODUCTINVENTORY_FAIL = "ADD_PRODUCTINVENTORY_FAIL"